import { render, staticRenderFns } from "./NewAppVersionModal.vue?vue&type=template&id=c0dede1e"
import script from "./NewAppVersionModal.vue?vue&type=script&lang=js"
export * from "./NewAppVersionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports